var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"my-3"},[_c('ListHeader',{attrs:{"text":"商品","value":"products"}}),_c('ListTable',{attrs:{"value":"products","items":_vm.products,"fields":_vm.fields},on:{"remove":_vm.removeProduct}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }